var unitTypes = [
  { name: 'SaleUnit', label: 'واحد فروش', value: 0, userType: 1 },
  { name: 'ProductionUnit', label: 'واحد تولید', value: 1, userType: 2 },
  {
    name: 'MaterialWarehouse',
    label: 'انبار مواد اولیه',
    value: 2,
    userType: 3,
    categoryType: 0
  },
  { name: 'ImpregnationUnit', label: 'واحد آغشته سازی', value: 3, userType: 4 },
  { name: 'PressUnit', label: 'واحد پرس', value: 4, userType: 6 },
  {
    name: 'SemiFinishedWarehouse',
    label: 'انبار نیمه ساخته',
    value: 5,
    userType: 13,
    categoryType: 1
  },
  { name: 'CuttingUnit', label: 'واحد برش', value: 6, userType: 8 },
  { name: 'ClickUnit', label: 'واحد کلیک', value: 7, userType: 10 },
  {
    name: 'Warehouse',
    label: 'انبار محصولات',
    value: 8,
    userType: 12,
    categoryType: 2
  },
  {
    name: 'WasteWarehouse',
    label: 'انبار ضایعات',
    value: 9,
    userType: 0,
    categoryType: -1
  }
]

export default unitTypes
